import Circular from "@/components/Circular";
import ConditionalTooltip from "@/components/ConditionalTooltip";
import { getSortingPillProps } from "@/utils/sortingPill";
import { FlashcardSortingEnum } from "@knowt/syncing/graphql/schema";

export const sortingTooltips: { [key in FlashcardSortingEnum]: string } = {
    [FlashcardSortingEnum.KNOW]: "Flashcards you know",
    [FlashcardSortingEnum.D_KNOW]: "Flashcards you still need to practice",
};

const SortingPill = ({ sort, style }: { sort?: FlashcardSortingEnum; style?: React.CSSProperties }) => {
    if (!sort) {
        return null;
    }

    const { backgroundColor, label, color } = getSortingPillProps(sort);

    return (
        <ConditionalTooltip tooltip={sortingTooltips[sort]}>
            <Circular
                radius="auto"
                style={{
                    width: "16rem",
                    minWidth: "16rem",
                    height: "4rem",
                    color,
                    backgroundColor,
                    gap: "0.8rem",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                    fontWeight: 600,
                    ...style,
                }}>
                {label}
            </Circular>
        </ConditionalTooltip>
    );
};

export default SortingPill;
